import { render, staticRenderFns } from "./LabPage.vue?vue&type=template&id=6ff5fb4d&scoped=true&"
import script from "./LabPage.vue?vue&type=script&lang=js&"
export * from "./LabPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff5fb4d",
  null
  
)

export default component.exports